module.exports = __webpack_public_path__ + "static/media/photo304.c4913292.jpg";